import React, {Component} from 'react';
import {
    Container,
    Row,
    Col,
    FormGroup,
    Label,
    Media,
    Input,
    FormText, FormFeedback, CustomInput
} from 'reactstrap';

import Button from '../../../shared/components/Button';
import Form from '../../../shared/components/Form';
import DroppableFileInput from '../../../shared/components/DroppableFileInput';
import ColorInput from '../../../shared/components/ColorInput';
import DateInput from "react-datepicker";
import moment from "moment-timezone";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {DABBL_PUBLISHER_ID, DEFAULT_TIMEZONE} from "../../../config";

const defaultImages = [
    {name: 'Not Selected', imageUrl: ''},
    {name: 'Issue', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/milestones/milestoneMessage.png'},
    {name: 'Feature', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/milestones/milestoneFeature.png'},
    {name: 'Money Related', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/milestones/milestonePiggybank.png'},
    {name: 'Promo 3X Survey', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/milestones/Survey3XPromo.png'},
    {name: 'Goya', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/milestones/milestoneGoya.png'},
    {name: '2X Survey promo 1', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/milestones/Dabb-2X-surveys-promo-01.png'},
    {name: '2X Survey promo 2', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/milestones/Dabb-2X-surveys-promo-02.png'},
    {name: '2X Survey promo 3', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/milestones/Dabb-2X-surveys-promo-03.png'},
    {name: '3 Days 3X Offerwall', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/milestones/3Day-3X-Offerwall.png'},
    {name: 'Triple Play', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/milestones/Dabbl-TriplePlay-Promo.png'},
]

class EditMilestone extends Component {

    constructor(props) {
        super(props);

        this.state = {
            colorValid: true,
            isUpdating: false,
            isActivating: false,
            isLoading:false,
            error: null,
            validateForm: false,
            isCreate: false
        }
    }

    componentWillMount() {
        const {milestone} = this.props
        if (milestone) {
            this.setState({...milestone,
                // isCustomImage: defaultImages.map(i=>i.imageUrl).indexOf(milestone.imageUrl) === -1,
                startDate: milestone.startDate ? moment(milestone.startDate).tz(DEFAULT_TIMEZONE) : moment().tz(DEFAULT_TIMEZONE).startOf('day'),
                expirationDate: milestone.expirationDate ? moment(milestone.expirationDate).tz(DEFAULT_TIMEZONE) : moment().tz(DEFAULT_TIMEZONE).startOf('day'),
                validateForm: true});
        } else {
            this.setState({
                isCreate: true,
                name: '',
                imageUrl: '',
                title: '',
                description: '',
                startDate: moment().tz(DEFAULT_TIMEZONE).startOf('day'),
                expirationDate:  moment().tz(DEFAULT_TIMEZONE).startOf('day').add(7, "day"),
                milestoneType: 'message'
            });
        }
    }

    componentWillUpdate(newProps, newState) {
        if (!newProps.isCreate && newProps.milestone && !this.props.milestone){
            const {milestone} = newProps
            this.setState({...milestone,
                // isCustomImage: defaultImages.map(i=>i.imageUrl).indexOf(milestone.imageUrl) === -1,
                startDate: milestone.startDate ? moment(milestone.startDate).tz(DEFAULT_TIMEZONE) : moment().tz(DEFAULT_TIMEZONE).startOf('day'),
                expirationDate: milestone.expirationDate ? moment(milestone.expirationDate).tz(DEFAULT_TIMEZONE) : moment().tz(DEFAULT_TIMEZONE).startOf('day'),
                validateForm: true,
                isCreate: false
            });
        }
    }

    componentDidMount(){
        if (this.props.needsLoading) {
            this.setState({isLoading:true});
            this.props.loadMilestones()
                .then(() => this.setState({isLoading:false}))
                .catch(() => this.setState({isLoading:false}));
        }
    }

    getImages() {
        const {milestones} = this.props
        let images = [...defaultImages]
        if (milestones) {
            for (const milestone of milestones.sort((a,b) => a.startDate > b.startDate ? 1 : -1)) {
                if (images.map(i => i.imageUrl).indexOf(milestone.imageUrl) === -1) {
                    images.push({name: `Image from: ${milestone.name}`, imageUrl: milestone.imageUrl})
                }
            }
        }
        return images
    }

    handleImageUrlChange(e, image){
        this.setState({ imageUrl: this.state.isCustomImage ? image.large : e.target.value })
    }

    handleUseCustomImageChange(e){
        if (e.target.checked || this.getImages().map(i => i.imageUrl).indexOf(this.state.imageUrl) === -1) {
            this.setState({ isCustomImage: e.target.checked, imageUrl: '' })
        } else {
            this.setState({ isCustomImage: e.target.checked})
        }
    }

    isValidMilestone() {
        const {name, title, description, imageUrl, startDate, expirationDate} = this.state
        return name && title && description && imageUrl && startDate <= expirationDate
    }

    handleSubmit(data) {
        console.debug("handleSubmit")
        if (!this.isValidMilestone()) {
            this.setState({validateForm: true})
            return
        }
        const milestone = this.props.milestone || {}
        const {loadMilestones} = this.props
        const {isCreate, name, title, description, imageUrl, startDate, expirationDate, milestoneType} = this.state
        const requestData = {
            ...(name !== milestone.name && {name: name}),
            ...(title !== milestone.title && {title: title}),
            ...(description !== milestone.description && {description: description}),
            ...(imageUrl !== milestone.imageUrl && {imageUrl: imageUrl}),
            ...((!milestone.startDate || startDate.format('LLL') !== moment(milestone.startDate).tz(DEFAULT_TIMEZONE).format('LLL')) && {startDate: moment.tz(startDate, DEFAULT_TIMEZONE).valueOf()}),
            ...((!milestone.expirationDate || expirationDate.format('LLL') !== moment(milestone.expirationDate).tz(DEFAULT_TIMEZONE).format('LLL')) && {expirationDate: moment.tz(expirationDate, DEFAULT_TIMEZONE).valueOf()}),
            ...(milestoneType !== milestone.milestoneType && {milestoneType: milestoneType}),
            ...(isCreate && {status: 'DRAFT'}),
            ...(isCreate && {retailerId: DABBL_PUBLISHER_ID}),
            ...(isCreate && {subtitle: ''})
        }
        this.setState({isUpdating: true, error: null});
            if (isCreate) {
                this.props.createMilestone({
                    ...requestData
                })
                    .then((res)=>res.instance.id)
                    .then((id) => { return loadMilestones()
                        .then(() => {
                            this.setState({isCreate: false})
                            this.props.history.replace(`${this.getBackLink()}/${id}`);
                            // window.location.reload();
                        } )})
                    .then((res) => this.handleSuccess())
                    // .then(() => this.componentWillMount())
                    .catch((err) => this.handleFailure(err));
            } else {
                this.props.updateMilestone(this.props.milestone.id, requestData)
                    .then((res) => this.handleSuccess())
                    .catch((err) => this.handleFailure(err));
            }
    }

    onActivateClick(){
        this.setState({isActivating: true, error: null});
        this.props.updateMilestone(this.props.milestone.id, {status: 'ACTIVE'})
            .then((res) => this.props.history.push(this.getBackLink(), {needUpdate: true}))
            // .then((res) => this.setState({status: 'active', isActivating: false}))
            .catch((err) => {
                console.log(err)
                try {
                    this.handleFailure(JSON.parse(err.message.replace(/'/g, '"')))
                } catch (e) {
                    this.handleFailure({message: err.message.replace(/'/g, '"')})
                }
            });
    }

    handleSuccess() {
        this.setState({isUpdating: false, isActivating: false});
    }

    handleFailure(err) {
        this.setState({error: err, isUpdating: false, isActivating: false});
    }

    getSubmitText() {
        if (this.state.isUpdating && this.state.isCreate) {
            return 'Creating';
        } else if (this.state.isUpdating) {
            return 'Updating';
        } else if (this.state.isCreate) {
            return 'Create';
        } else {
            return 'Update';
        }
    }

    getBackLink() {
        return this.props.match.url.substring(0, this.props.match.url.lastIndexOf('/'));
    }

    render() {
        const {
            milestone
        } = this.props;
        const {isCreate, name, title, description, imageUrl, startDate, expirationDate, milestoneType, status} = this.state

        const {
            isUpdating,
            isActivating,
            isCustomImage,
            validateForm,
            error
        } = this.state;

        if (this.state.isLoading) {
            return <div>Loading...</div>
        }

        if (!isCreate && !milestone) {
            return <div>Milestone failed to load</div>
        }

        return (
            <Container className="EditMilestone">
                <Row>
                    <Col xs='10'>
                        <h3>{isCreate ? 'Create Milestone' : `Edit ${milestone.name}`}</h3>
                    </Col>
                </Row>
                <Row>
                    <Col xs='10'>
                        Milestones present messaging to users when they open the Dabbl app.  Does not currently apply to other apps or publishers.
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form onSubmit={this.handleSubmit.bind(this)}>
                            <FormGroup row>
                                <Label for="name" sm={4}>Name</Label>
                                <Col sm={8}>
                                    <Input name="name"
                                           id="name"
                                           defaultValue={name}
                                           onChange={(e) => this.setState({ name: e.target.value })}
                                           invalid={(!name || name.length === 0) && validateForm}/>
                                    {(!name || name.length === 0) && <FormFeedback>Name is required</FormFeedback> }
                                    <FormText>Title of milestone (not seen by users) </FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="selectImageUrl" sm={4}>Image</Label>
                                <Col sm={8}>
                                    <Row id="retailers">
                                        <Col xs="auto">
                                            <CustomInput type="switch" id='isCustomImage' name='isCustomImage' label='Use Custom Image' checked={isCustomImage} onChange={(e) => this.handleUseCustomImageChange(e)}/>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={10}>
                                            {isCustomImage ?
                                                <DroppableFileInput
                                                    id='productImageUrl'
                                                    text='Product Image'
                                                    fileType='image'
                                                    onChange={(image) => this.handleImageUrlChange(undefined, image)}
                                                    cropperAspectRatio={1}
                                                    existingFileName={imageUrl ? imageUrl .split('/').pop(): ''}
                                                    existingFileURL={imageUrl }
                                                    warning={ imageUrl  || !validateForm ? '' : 'Product image is required'}
                                                /> :
                                                <CustomInput type="select" name="selectImageUrl"
                                                             id='selectImageUrl'
                                                             defaultValue={imageUrl}
                                                             invalid={(!imageUrl || imageUrl.length === 0) && validateForm}
                                                             onChange={(e) => this.handleImageUrlChange(e)}>
                                                    {this.getImages().map((i) => (
                                                        <option key={i.imageUrl} value={i.imageUrl}>{i.name}</option>
                                                    ))}
                                                </CustomInput>
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}>
                                            <Media>
                                                <Media left middle object src={imageUrl} style={{maxHeight:'256px', maxWidth:'256px'}} alt={''} />
                                            </Media>
                                        </Col>
                                    </Row>
                                    <FormFeedback>Image for milestone is required</FormFeedback>
                                    <Row><Col sm={12}><FormText>Select image for milestone.</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="title" sm={4}>Title</Label>
                                <Col sm={8}>
                                    <Input name="title"
                                           id="title"
                                           defaultValue={title}
                                           onChange={(e) => this.setState({ title: e.target.value})}
                                           invalid={(!title || title.length === 0) && validateForm}/>
                                    {(!title || title.length === 0) && <FormFeedback>Title is required</FormFeedback> }
                                    <FormText>What should the headline say?</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="description" sm={4}>Description</Label>
                                <Col sm={8}>
                                    <ReactQuill name="description"
                                                id="description"
                                                defaultValue={description}
                                                onChange={(value) => this.setState({ description: value})}
                                                invalid={(!description || description.length === 0) && validateForm} />
                                    <FormFeedback>Description is required</FormFeedback>
                                    <FormText>What should the message say? </FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for='startDate'>Start Date</Label>
                                <Col sm={8}>
                                    <Row>
                                        <Col sm={4}>
                                    <DateInput id='startDate'
                                               className='form-control'
                                               minDate={moment().tz(DEFAULT_TIMEZONE).startOf("day")}
                                               selected={startDate}
                                               onChange={(d) => this.setState({startDate: moment.tz([d.year(), d.month(), d.date(), startDate.hour(), startDate.minute(),startDate.second()], DEFAULT_TIMEZONE)})}
                                    /></Col>
                                        <Col sm={4}>
                                            <Input
                                                type="time"
                                                name="startTime"
                                                id="startTime"
                                                value={startDate.format("HH:mm")}
                                                placeholder="start time"
                                                onChange={(e) => {
                                                    console.log(e.target.value)
                                                    this.setState({startDate: startDate.startOf("day").add(moment.duration(e.target.value))})
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                    <FormFeedback>Incorrect Date</FormFeedback>
                                    <Row><Col sm={12}><FormText>When should this milestone appear to users?</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for='expirationDate'>Expiration Date</Label>
                                <Col sm={8}>
                                <Row>
                                    <Col sm={4}>
                                    <DateInput id='expirationDate'
                                               className='form-control'
                                               disabled={!startDate}
                                               minDate={startDate || moment().tz(DEFAULT_TIMEZONE).startOf("day")}
                                               selected={expirationDate}
                                               onChange={(d) => {
                                                   this.setState({expirationDate: moment.tz([d.year(), d.month(), d.date(), expirationDate.hour(), expirationDate.minute(),expirationDate.second()], DEFAULT_TIMEZONE)});
                                               } }
                                    />
                                    </Col>
                                    <Col sm={4}>
                                        <Input
                                            type="time"
                                            name="endTime"
                                            id="endTime"
                                            value={expirationDate.format("HH:mm")}
                                            placeholder="end time"
                                            onChange={(e) => {
                                                console.log(e.target.value)
                                                this.setState({expirationDate: expirationDate.startOf("day").add(moment.duration(e.target.value))})
                                            }}
                                        />
                                    </Col>
                                </Row>
                                    {startDate > expirationDate && validateForm &&
                                    <FormText color='danger'>Expiration date should be greater than start date</FormText>
                                    }
                                    <Row><Col sm={12}><FormText sm={12}>When should this milestone be removed from app?</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="milestoneType" sm={4}>Message Type</Label>
                                <Col sm={8}>
                                    <CustomInput type="select" name="milestoneType"
                                                 id='milestoneType'
                                                 defaultValue={milestoneType}
                                                 invalid={(!milestoneType || milestoneType.length === 0) && validateForm}
                                                 onChange={(e) => this.setState({ milestoneType: e.target.value})}>
                                        <option key='message' value='message'>All Users</option>
                                        <option key='feature' value='feature'>Limited Target</option>
                                    </CustomInput>
                                    {(!milestoneType || milestoneType.length === 0) && <FormFeedback>Message Type is required</FormFeedback> }
                                    <FormText>Limited Target means users would be configured on backend</FormText>
                                </Col>
                            </FormGroup>
                            <br/>
                            {error &&
                                <div>
                                    { Object.entries(error).map(([key, value]) => <FormText color='danger' key={value}>{value}</FormText>)}
                                    <br/>
                                </div>
                            }
                            <div>
                                <Button isSubmit disabled={isUpdating}>{this.getSubmitText()}</Button>
                                { status === 'DRAFT' &&
                                    <Button className='ml-2' disabled={isUpdating || isActivating || !this.isValidMilestone()}
                                            onClick={() => this.onActivateClick()}>{this.state.isActivating ? 'Activating...' : 'Activate'}</Button>
                                }
                                <Button
                                    linkHref={this.getBackLink()}
                                    className='float-right'
                                    textColor='#666666'
                                    borderColor='#cccccc'
                                    backgroundColor='#ededed'> Cancel </Button>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default EditMilestone;



// WEBPACK FOOTER //
// ./src/routes/EditMilestone/components/EditMilestone.js